import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { OccurrenceTypeService } from '../../../core/services/occurrence/occurrence-type/occurrence-type.service'

@Component({
  selector: 'occurrence-type-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatFormField,
    MatInput,
    MatLabel,
  ],
  templateUrl: './occurrence-type-create.component.html',
  styleUrl: './occurrence-type-create.component.scss',
  providers: [OccurrenceTypeService],
  standalone: true,
})
export class OccurrenceTypeCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private occurrenceTypeService: OccurrenceTypeService,
    private snackbar: SnackbarCustomService,
  ) {}

  @Output() responseCreate = new EventEmitter()

  form: FormGroup = new FormGroup({})
  loading = false

  ngOnInit(): void {
    this.createForm()
  }

  createItem() {
    this.loading = true
    const model = this.createModel()
    this.occurrenceTypeService.createOccurrenceType(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  createModel() {
    return {
      descricao: this.form.controls['description'].value,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      description: ['', [Validators.required]],
    })
  }
}
